import URIS from 'constants/uris';
import http from 'services/http';

getMerchantCategories.operation = 'READ';
getMerchantCategories.idFrom = 'ARGS';
export function getMerchantCategories(params) {
  return http.get(`${URIS.MERCHANT_CATEGORIES}`, { params });
}
